// Client-safe environment config
// These values are replaced by webpack DefinePlugin at build time

export const DEBUG = process.env.DEBUG;
export const APP_VERSION = process.env.APP_VERSION;
export const NODE_ENV = process.env.NODE_ENV;
export const IS_DEVELOPMENT = process.env.IS_DEVELOPMENT;
export const IS_PRODUCTION = process.env.IS_PRODUCTION;
export const API_HOST_SERVER = process.env.API_HOST_SERVER;
export const API_HOST_CLIENT = process.env.API_HOST_CLIENT;
export const SUGGEST_API = process.env.SUGGEST_API;
export const IS_CLIENT = process.env.IS_CLIENT;
export const IS_SERVER = process.env.IS_SERVER;
export const SITE_NAME = process.env.SITE_NAME;
export const SITE_URL = process.env.SITE_URL;
export const IOS_APP_ID = process.env.IOS_APP_ID;
export const GOOGLE_APP_ID = process.env.GOOGLE_APP_ID;
export const FACEBOOK_APP_ID = process.env.FACEBOOK_APP_ID;
export const STATIC_ASSETS_CACHE_TIME_IN_SECONDS = process.env.STATIC_ASSETS_CACHE_TIME_IN_SECONDS;
export const ASSET_PATH = process.env.ASSET_PATH;
export const HOST = process.env.HOST;
export const PORT = process.env.PORT;
export const DISPLAY_ACCESS_LOGS = process.env.DISPLAY_ACCESS_LOGS;